import api from './api';

const offerService = {
  getAll: async () => {
    const response = await api.get('/offers');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/offers/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/offers', data);
    return response.data;
  },
  updateStatus: async (id, status) => {
    const response = await api.put(`/offers/${id}/status`, { status });
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/offers/${id}`);
    return response.data;
  }
};

export default offerService;